import {Component, Input} from '@angular/core';
import {PoState} from "../../../model";

@Component({
    selector: 'app-batch-status-icon',
    templateUrl: './batch-status-icon.component.html',
    styleUrls: ['./batch-status-icon.component.scss'],
    standalone: false
})
export class BatchStatusIconComponent {
  @Input()
  status: PoState | undefined;

  PoState = PoState;
}
